export const HERO_IMAGE = {
    url: "/hero-poster.webp",
    alt: "Monumental sculptural concrete geometry with natural sunlight interplay",
    captionPt: "Arquivo do Atelier · Coimbra",
    captionEn: "Studio Archive · Coimbra",
};

export const STUDIO_IMAGE = {
    url: "/atelier-grande.webp",
    alt: "Sala de trabalho do atelier VALRIO em Coimbra — luz natural sobre a zona de desenho",
    captionPt: "VALRIO",
    captionEn: "VALRIO",
};

export const STUDIO_IMAGE_2 = {
    url: "/atelier-pequena.webp",
    alt: "Receção do atelier VALRIO — poltronas, arte e café",
};

export const PROJECTS = [
    {
        id: "casa-monsanto",
        title: "Casa da Rocha",
        titleEn: "Casa da Rocha",
        location: "Maínça - Coimbra",
        locationEn: "Maínça - Coimbra",
        year: "2026",
        category: "residential",
        categoryLabel: "Habitação Unifamiliar",
        categoryLabelEn: "Private Residence",
        area: "480 m²",
        awards: "Finalista Prémio Secil de Arquitetura",
        awardsEn: "Secil Architecture Prize Finalist",
        image: "/projects/casa-da-rocha/01-principal-piscina.webp",
        summary: "Geometrias puras em betão branco e vãos profundos que enquadram o Tejo e o pinhal circundante.",
        summaryEn: "Pure geometries in white concrete with deep openings framing the Tagus and the surrounding pinewood.",
    },
    {
        id: "quinta-douro",
        title: "Lote 10",
        titleEn: "Lote 10",
        location: "ZIVV Oliveira do Bairro",
        locationEn: "ZIVV Oliveira do Bairro",
        year: "2026",
        category: "hospitality",
        categoryLabel: "Pavilhão Industrial",
        categoryLabelEn: "Industrial Pavilion",
        area: "1.250 m²",
        awards: "Nomeado ArchDaily Building of the Year",
        awardsEn: "ArchDaily Building of the Year Nominee",
        image: "/projects/lote-10/01-principal-fachada.webp",
        summary: "Cantiléver sobre os socalcos xistosos com espelho de água contínuo e brises em madeira de castanho.",
        summaryEn: "A cantilever above schist terraces with a continuous water mirror and chestnut timber brise-soleils.",
    },
    {
        id: "palacete-chiado",
        title: "Casa da Bicada",
        titleEn: "Casa da Bicada",
        location: "Aljustrel",
        locationEn: "Aljustrel",
        year: "2025",
        category: "rehab",
        categoryLabel: "Habitação Unifamiliar",
        categoryLabelEn: "Private Residence",
        area: "820 m²",
        awards: "Menção Honrosa · Prémio Nacional de Reabilitação Urbana",
        awardsEn: "Honorable Mention · National Urban Rehabilitation Prize",
        image: "/projects/casa-da-bicada/01-principal-fachada.webp",
        summary: "Fusão cirúrgica de estuques oitocentistas restaurados com vãos em arco e mobiliário monolítico em nogueira.",
        summaryEn: "A surgical fusion of restored 19th-century stuccowork with arched openings and monolithic walnut joinery.",
    },
    {
        id: "museu-alcantara",
        title: "Casa Do Canal",
        titleEn: "Casa Do Canal",
        location: "Aljustrel",
        locationEn: "Aljustrel",
        year: "2025",
        category: "culture",
        categoryLabel: "Habitação Unifamiliar",
        categoryLabelEn: "Private Residence",
        area: "2.400 m²",
        awards: "1º Lugar · Concurso Público Internacional",
        awardsEn: "1st Prize · International Public Competition",
        image: "/projects/casa-do-canal/01-principal-alpendre.webp",
        summary: "Volumes rítmicos em betão cofrado a réguas de pinho que modulam sombras fortes sob o sol lisboeta.",
        summaryEn: "Rhythmic volumes in pine-board-formed concrete modulating sharp shadows beneath the Lisbon sun.",
    },
    {
        id: "villa-comporta",
        title: "Casa do Monte Além",
        titleEn: "Casa do Monte Além",
        location: "Aljustrel",
        locationEn: "Aljustrel",
        year: "2025",
        category: "residential",
        categoryLabel: "Habitação Unifamiliar",
        categoryLabelEn: "Private Residence",
        area: "360 m²",
        awards: "Publicado na revista El Croquis",
        awardsEn: "Published in El Croquis magazine",
        image: "/projects/casa-do-monte-alem/01-principal-piscina.webp",
        summary: "Plataforma térrea que flutua delicadamente sobre as dunas com pátios internos e ventilação cruzada natural.",
        summaryEn: "A single-storey platform floating gently over the dunes, with inner patios and natural cross-ventilation.",
    },
    {
        id: "espaco-avenidas",
        title: "Reabilitação dos Marcos",
        titleEn: "Reabilitação dos Marcos",
        location: "Aljustrel",
        locationEn: "Aljustrel",
        year: "2026",
        category: "residential",
        categoryLabel: "Habitação Multifamiliar",
        categoryLabelEn: "Multifamily Housing",
        area: "310 m²",
        awards: "Selecionado · Prémio FAD de Arquitetura",
        awardsEn: "Selected · FAD Architecture Prize",
        image: "/projects/reabilitacao-dos-marcos/01-principal-patio-bambu.webp",
        summary: "Espaço de pé-direito duplo unificado por pavimento em betonilha afagada e caixilharias minimalistas em aço corten.",
        summaryEn: "A double-height space unified by polished screed flooring and minimalist corten steel window frames.",
    },
];

export const SHOWREEL = {
    video: "https://videos.pexels.com/video-files/6076828/6076828-hd_1920_1080_30fps.mp4",
    videoFallback: "https://videos.pexels.com/video-files/7311571/7311571-uhd_2732_1318_30fps.mp4",
    badge: { pt: "MATÉRIA & LUZ · ARQUIVO VALRIO", en: "MATTER & LIGHT · VALRIO ARCHIVE" },
    soundOn: { pt: "Ativar som", en: "Unmute" },
    soundOff: { pt: "Silenciar", en: "Mute" },
    playLabel: { pt: "Reproduzir", en: "Play" },
    pauseLabel: { pt: "Pausa", en: "Pause" },
    links: [
        { id: "sobre", target: "#atelier", label: { pt: "Sobre", en: "Studio" } },
        { id: "morada", target: "#contacto", label: { pt: "Morada", en: "Address" } },
        { id: "obras", target: "#projetos", label: { pt: "Obras", en: "Works" } },
        { id: "servicos", target: "#servicos", label: { pt: "Serviços", en: "Services" } },
        { id: "contacto", target: "#contacto", label: { pt: "Contacto", en: "Contact" } },
    ],
};

export const GALLERIES = {
    "casa-monsanto": [
        "/projects/casa-da-rocha/02-entrada.webp",
        "/projects/casa-da-rocha/03-fachada.webp",
        "/projects/casa-da-rocha/04-terraco.webp",
        "/projects/casa-da-rocha/05-interior.webp",
    ],
    "quinta-douro": [
        "/projects/lote-10/02-lateral.webp",
        "/projects/lote-10/03-estacionamento.webp",
    ],
    "palacete-chiado": [
        "/projects/casa-da-bicada/02-terraco.webp",
        "/projects/casa-da-bicada/03-piscina.webp",
        "/projects/casa-da-bicada/04-sala.webp",
        "/projects/casa-da-bicada/05-cozinha.webp",
    ],
    "museu-alcantara": [
        "/projects/casa-do-canal/02-fachada.webp",
        "/projects/casa-do-canal/03-sala.webp",
        "/projects/casa-do-canal/04-cozinha.webp",
        "/projects/casa-do-canal/05-quarto.webp",
    ],
    "villa-comporta": [
        "/projects/casa-do-monte-alem/02-fachada-rua.webp",
        "/projects/casa-do-monte-alem/03-sala.webp",
        "/projects/casa-do-monte-alem/04-hall.webp",
        "/projects/casa-do-monte-alem/05-quarto.webp",
    ],
    "espaco-avenidas": [
        "/projects/reabilitacao-dos-marcos/02-cozinha.webp",
        "/projects/reabilitacao-dos-marcos/03-sala-tv.webp",
        "/projects/reabilitacao-dos-marcos/04-patio-monstera.webp",
        "/projects/reabilitacao-dos-marcos/05-sala-jantar.webp",
    ],
};

export const content = {
    pt: {
        nav: {
            inicio: "Início",
            sobre: "Sobre Nós",
            portfolio: "Portefólio",
            contactos: "Contactos",
            projects: "Projetos",
            studio: "O Atelier",
            services: "Serviços",
            philosophy: "Filosofia",
            contact: "Contacto",
            cta: "Iniciar Conversa",
            menu: "Menu",
        },
        hero: {
            eyebrow: "ATELIER DE ARQUITETURA · COIMBRA",
            titleLines: [
                "ARQUITETURA, ENGENHARIA",
                "E FISCALIZAÇÃO",
            ],
            subtitle:
                "A Valrio é um escritório de arquitectura sediado em Coimbra. Desenvolve projectos de arquitectura, urbanismo, engenharia e reabilitação de edifícios. O escritório acompanha o cliente em todas as fases: levantamento, projecto de licenciamento, projecto de execução e acompanhamento de obra.",
            ctaProjects: "Explorar Obras",
            ctaContact: "Iniciar Conversa",
            scrollHint: "Deslize para descobrir",
            metrics: [
                { value: "18+", label: "Anos de prática" },
                { value: "42", label: "Obras concluídas" },
                { value: "07", label: "Prémios nacionais & ibéricos" },
            ],
        },
        marquee: [
            "PROJETOS RESIDENCIAIS, COMERCIAIS E INDUSTRIAIS",
            "DESIGN DE INTERIORES",
            "REABILITAÇÃO DE EDIFÍCIOS",
        ],
        about: {
            eyebrow: "A NOSSA MATRIZ",
            title: "Da ideia ao lugar.",
            p1: "A Valrio é um escritório de arquitetura sediado em Coimbra, dedicado ao desenvolvimento de projetos de arquitetura, urbanismo, engenharia e reabilitação de edifícios. Trabalhamos cada projeto de forma integrada, desde o levantamento e estudo inicial até ao projeto de licenciamento, projeto de execução e acompanhamento de obra.",
            p2: "Procuramos compreender cada contexto, cada necessidade e cada lugar para encontrar soluções rigorosas, funcionais e adequadas a quem as vai habitar ou utilizar.",
            p3: "Acreditamos que um bom projeto nasce da relação entre as pessoas, o espaço e o contexto. Por isso, mantemos um acompanhamento próximo ao longo de todo o processo, articulando as diferentes especialidades e garantindo coerência entre a ideia, o projeto e a obra.",
            materialsLabel: "PALETA DE MATERIAIS",
            materials: ["Betão Aparente", "Pedra", "Reboco de Cal", "Madeira Maciça"],
            quote: "«Construir não é impor um objeto ao solo; é revelar o que a paisagem sempre esteve à espera de dizer.»",
            quoteAuthor: "Atelier VALRIO",
        },
        services: {
            eyebrow: "SERVIÇOS",
            title: "Do detalhe de carpintaria ao plano diretor",
            items: [
                {
                    num: "01",
                    title: "Arquitetura",
                    desc: "Projetos residenciais, comerciais e industriais · Design de interiores · Reabilitação de edifícios.",
                },
                {
                    num: "02",
                    title: "Engenharia",
                    desc: "Engenharia e consultoria técnica · Planeamento e análise de viabilidade.",
                },
                {
                    num: "03",
                    title: "Acompanhamento de Obra",
                    desc: "Gestão e coordenação da execução de projetos · Controlo de qualidade e cronograma.",
                },
                {
                    num: "04",
                    title: "Metodologia BIM",
                    desc: "Planeamento integrado e simulações tridimensionais · Redução de erros e otimização de recursos · Coordenação entre arquitetos, engenheiros e construtores.",
                },
            ],
        },
        portfolio: {
            eyebrow: "SELEÇÃO DE OBRAS",
            title: "Projetos Selecionados",
            filters: [
                { key: "all", label: "Todos" },
                { key: "residential", label: "Residencial" },
                { key: "rehab", label: "Reabilitação" },
                { key: "hospitality", label: "Hotelaria" },
                { key: "culture", label: "Cultural" },
            ],
            notice: "Todos os direitos reservados. As fotografias e imagens presentes neste website não podem ser reproduzidas ou utilizadas sem autorização.",
            viewProject: "Ver galeria",
            modal: {
                location: "Localização",
                year: "Ano",
                typology: "Tipologia",
                area: "Área",
                awards: "Distinções",
                concept: "Conceito",
                close: "Fechar",
            },
        },
        contact: {
            eyebrow: "CONTACTO",
            title: "Vamos desenhar o seu próximo espaço.",
            subtitle:
                "Recebemos novos projetos residenciais e comerciais em Portugal e no estrangeiro.",
            form: {
                name: "Nome",
                namePlaceholder: "Ex: Dra. Mariana Vasconcelos",
                email: "Correio Eletrónico",
                emailPlaceholder: "mariana@exemplo.pt",
                phone: "Telefone / Telemóvel",
                phonePlaceholder: "+351 912 345 678",
                subject: "Tipologia da Consulta",
                subjectPlaceholder: "Selecione a tipologia",
                subjectOptions: [
                    "Nova Moradia Unifamiliar",
                    "Reabilitação de Edifício",
                    "Projeto Comercial / Hotelaria",
                    "Consultoria Urbanística",
                    "Imprensa & Parcerias",
                ],
                message: "Descrição do Projeto / Localização / Prazos",
                messagePlaceholder:
                    "Partilhe o terreno ou imóvel existente, localização aproximada e intenções...",
                consent: "Autorizo o tratamento dos dados submetidos para resposta à minha solicitação, de acordo com o RGPD.",
                privacyLink: "Política de Privacidade",
                submit: "Enviar Mensagem",
                sending: "A enviar proposta...",
                success:
                    "Mensagem recebida com sucesso. O atelier entrará em contacto num prazo de 24 horas úteis.",
                error:
                    "Ocorreu um erro no envio. Por favor tente novamente ou contacte-nos diretamente por telefone.",
            },
            address: {
                label: "MORADA DO ESCRITÓRIO",
                line1: "Avenida Fernão de Magalhães",
                line2: "401 — 2A",
                line3: "3000-177 Coimbra, Portugal",
                phoneLabel: "TELEFONES",
                phones: [
                    { num: "+351 915 708 468", name: "Pedro Freire" },
                    { num: "+351 913 758 194", name: "Ângela Cardoso" },
                ],
                emailLabel: "EMAIL",
                email: "geral@valrio.pt",
                scheduleLabel: "HORÁRIO",
                schedule: "Segunda - Sexta · 09h00 — 18h00",
            },
        },
        privacy: {
            title: "Política de Privacidade e Proteção de Dados (RGPD)",
            close: "Fechar",
            sections: [
                {
                    h: "1. Responsável pelo Tratamento",
                    p: "VALRIO ARQUITETURA LDA · Avenida Fernão de Magalhães, nº 401 — 2A, 3000-177 Coimbra, Portugal · geral@valrio.pt",
                },
                {
                    h: "2. Finalidades do Tratamento",
                    p: "Os dados pessoais recolhidos através do formulário de contacto (nome, email, telefone e descrição do projeto) destinam-se exclusivamente à resposta à sua consulta profissional, preparação de propostas e comunicações diretamente relacionadas com o pedido.",
                },
                {
                    h: "3. Fundamento Jurídico",
                    p: "O tratamento baseia-se no consentimento expresso do titular (art. 6.º, n.º 1, al. a) do RGPD), assinalado através da caixa de autorização no formulário de contacto.",
                },
                {
                    h: "4. Conservação dos Dados",
                    p: "Os dados são conservados pelo período máximo de 24 meses após o último contacto, findo o qual são eliminados de forma segura, salvo obrigação legal em contrário.",
                },
                {
                    h: "5. Partilha com Terceiros",
                    p: "Os seus dados nunca serão vendidos, cedidos ou partilhados com terceiros para fins comerciais ou de marketing sem consentimento formal e explícito.",
                },
                {
                    h: "6. Direitos do Titular",
                    p: "Pode exercer a qualquer momento os direitos de acesso, retificação, apagamento, limitação, portabilidade e oposição ao tratamento, mediante pedido escrito para geral@valrio.pt. Tem igualmente o direito de apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD).",
                },
            ],
        },
        footer: {
            legalTitle: "Informação Legal & RGPD",
            privacySummary:
                "VALRIO · Os dados pessoais facultados neste sítio destinam-se exclusivamente ao tratamento de consultas profissionais e nunca serão partilhados com terceiros sem consentimento formal.",
            privacyLink: "Política de Privacidade e Proteção de Dados (RGPD)",
            oa: "Atelier registado na Ordem dos Arquitectos",
            satellite: "Coimbra · Portugal",
            rights: "© 2026 VALRIO™. Todos os direitos reservados.",
            backToTop: "Voltar ao topo",
            navTitle: "Navegação",
            contactTitle: "Contactos",
        },
    },
    en: {
        nav: {
            inicio: "Home",
            sobre: "About Us",
            portfolio: "Portfolio",
            contactos: "Contacts",
            projects: "Projects",
            studio: "The Studio",
            services: "Services",
            philosophy: "Philosophy",
            contact: "Contact",
            cta: "Start Conversation",
            menu: "Menu",
        },
        hero: {
            eyebrow: "ARCHITECTURE STUDIO · COIMBRA",
            titleLines: [
                "ARCHITECTURE, ENGINEERING",
                "AND SITE SUPERVISION",
            ],
            subtitle:
                "Valrio is an architecture practice based in Coimbra. We develop architecture, urban planning, engineering and building rehabilitation projects, accompanying the client through every phase: site survey, licensing design, execution design and construction supervision.",
            ctaProjects: "View Works",
            ctaContact: "Start Conversation",
            scrollHint: "Scroll to discover",
            metrics: [
                { value: "18+", label: "Years of practice" },
                { value: "42", label: "Completed works" },
                { value: "07", label: "National & Iberian awards" },
            ],
        },
        marquee: [
            "RESIDENTIAL, COMMERCIAL & INDUSTRIAL PROJECTS",
            "INTERIOR DESIGN",
            "BUILDING REHABILITATION",
        ],
        about: {
            eyebrow: "OUR CORE",
            title: "From idea to place.",
            p1: "Valrio is an architecture practice based in Coimbra, dedicated to architecture, urban planning, engineering and building rehabilitation projects. We approach every project in an integrated way, from the initial survey and study through to licensing design, execution design and construction supervision.",
            p2: "We seek to understand each context, each need and each place, to find rigorous, functional solutions suited to those who will inhabit or use them.",
            p3: "We believe a good project is born from the relationship between people, space and context. That is why we stay closely involved throughout the entire process, coordinating the different specialties and ensuring coherence between the idea, the design and the construction.",
            materialsLabel: "MATERIAL PALETTE",
            materials: ["Fair-faced Concrete", "Stone", "Lime Plaster", "Solid Timber"],
            quote: "«To build is not to impose an object onto the soil; it is to reveal what the landscape was always waiting to express.»",
            quoteAuthor: "VALRIO Studio",
        },
        services: {
            eyebrow: "SERVICES",
            title: "From bespoke millwork to urban masterplans",
            items: [
                {
                    num: "01",
                    title: "Architecture",
                    desc: "Residential, commercial and industrial projects · Interior design · Building rehabilitation.",
                },
                {
                    num: "02",
                    title: "Engineering",
                    desc: "Engineering and technical consultancy · Planning and feasibility analysis.",
                },
                {
                    num: "03",
                    title: "Construction Supervision",
                    desc: "Management and coordination of project execution · Quality control and scheduling.",
                },
                {
                    num: "04",
                    title: "BIM Methodology",
                    desc: "Integrated planning and 3D simulations · Error reduction and resource optimization · Coordination between architects, engineers and builders.",
                },
            ],
        },
        portfolio: {
            eyebrow: "SELECTED WORKS",
            title: "Selected Works",
            filters: [
                { key: "all", label: "All" },
                { key: "residential", label: "Residential" },
                { key: "rehab", label: "Heritage" },
                { key: "hospitality", label: "Hospitality" },
                { key: "culture", label: "Cultural" },
            ],
            notice: "All rights reserved. The photographs and images on this website may not be reproduced or used without authorization.",
            viewProject: "View gallery",
            modal: {
                location: "Location",
                year: "Year",
                typology: "Typology",
                area: "Area",
                awards: "Distinctions",
                concept: "Concept",
                close: "Close",
            },
        },
        contact: {
            eyebrow: "CONTACT",
            title: "Let us shape your next space.",
            subtitle:
                "Accepting commissions for bespoke residential and institutional projects in Portugal and abroad.",
            form: {
                name: "Name",
                namePlaceholder: "e.g., Katherine Wright",
                email: "Email Address",
                emailPlaceholder: "katherine@domain.com",
                phone: "Phone / Mobile",
                phonePlaceholder: "+351 912 345 678",
                subject: "Inquiry Type",
                subjectPlaceholder: "Select inquiry type",
                subjectOptions: [
                    "New Private Residence",
                    "Heritage Renovation",
                    "Commercial / Hospitality",
                    "Urban Advisory",
                    "Press & Collaborations",
                ],
                message: "Project Description / Location / Timeline",
                messagePlaceholder:
                    "Tell us about your plot, existing property, location, and intentions...",
                consent:
                    "I consent to the processing of my submitted details to handle this inquiry, in accordance with GDPR/RGPD regulations.",
                privacyLink: "Privacy Policy",
                submit: "Send Inquiry",
                sending: "Transmitting...",
                success:
                    "Inquiry transmitted successfully. Our studio will respond within 24 business hours.",
                error:
                    "Submission error. Please try again or reach our studio directly by phone.",
            },
            address: {
                label: "OFFICE ADDRESS",
                line1: "Avenida Fernão de Magalhães",
                line2: "401 — 2A",
                line3: "3000-177 Coimbra, Portugal",
                phoneLabel: "DIRECT LINES",
                phones: [
                    { num: "+351 915 708 468", name: "Pedro Freire" },
                    { num: "+351 913 758 194", name: "Ângela Cardoso" },
                ],
                emailLabel: "EMAIL",
                email: "geral@valrio.pt",
                scheduleLabel: "OFFICE HOURS",
                schedule: "Monday - Friday · 09:00 — 18:00",
            },
        },
        privacy: {
            title: "Privacy & Data Protection Notice (RGPD/GDPR)",
            close: "Close",
            sections: [
                {
                    h: "1. Data Controller",
                    p: "VALRIO ARQUITETURA LDA · Avenida Fernão de Magalhães, No. 401 — 2A, 3000-177 Coimbra, Portugal · geral@valrio.pt",
                },
                {
                    h: "2. Purposes of Processing",
                    p: "Personal data collected through the contact form (name, email, phone and project description) is used exclusively to respond to your professional inquiry, prepare proposals, and communicate matters directly related to your request.",
                },
                {
                    h: "3. Legal Basis",
                    p: "Processing is based on the data subject's explicit consent (Art. 6(1)(a) GDPR), given through the authorization checkbox in the contact form.",
                },
                {
                    h: "4. Data Retention",
                    p: "Data is retained for a maximum of 24 months after the last contact, after which it is securely deleted, unless a legal obligation requires otherwise.",
                },
                {
                    h: "5. Third-Party Sharing",
                    p: "Your data will never be sold, transferred, or shared with third parties for commercial or marketing purposes without formal and explicit consent.",
                },
                {
                    h: "6. Data Subject Rights",
                    p: "You may exercise your rights of access, rectification, erasure, restriction, portability, and objection at any time by written request to geral@valrio.pt. You also have the right to lodge a complaint with the Portuguese Data Protection Authority (CNPD).",
                },
            ],
        },
        footer: {
            legalTitle: "Legal Notice & GDPR",
            privacySummary:
                "VALRIO · Personal data submitted via this platform is used solely to respond to architectural inquiries and is protected under EU GDPR standards.",
            privacyLink: "Privacy & Data Protection Notice (RGPD/GDPR)",
            oa: "Registered with the Portuguese Order of Architects",
            satellite: "Coimbra · Portugal",
            rights: "© 2026 VALRIO™. All rights reserved.",
            backToTop: "Back to top",
            navTitle: "Navigation",
            contactTitle: "Contact",
        },
    },
};
